import React from "react";
import PropTypes from "prop-types";

export default function SkipToHere({ contentId = "MainContent", children, tabIndex = -1 }) {
  return (
    <div id={contentId} tabIndex={tabIndex}>
      {children}
    </div>
  );
}

SkipToHere.propTypes = {
  /** Id attribute for wrapper div. */
  contentId: PropTypes.string,
  /** Use -1 for JS only focus, 0 for keyboard and js focus. */
  tabIndex: PropTypes.oneOf([-1, 0]),
};
